import React, { useContext, useEffect } from 'react';
import { AccountContext } from 'src/context/AccountContext';
import { IAccountContext } from 'src/context/AccountContext.interface';
import { generateSiteLoadEvent } from 'src/utility/Utilities';
import { useMessageContext } from 'src/context/MessageContext';
import { ISubjectMappingResponse } from 'src/context/MessageContext.interface';
import LeaseFAQ from 'src/views/components/faq/LeaseFAQ';
import BalloonFAQ from 'src/views/components/faq/BalloonFAQ';
import { FAQComponentProps } from 'src/views/components/faq/FAQComponent';
import LoanFAQ from 'src/views/components/faq/LoanFAQ';
import FAQComponentCanada from '../../components/faq/FAQComponentCanada';
import { AccountType, Brand, Country } from '../../../types';

const FAQByAccountType: React.FC<FAQComponentProps> = ({ accountType, brand, mobile }) => {
  switch (accountType) {
    case AccountType.Lease:
      return <LeaseFAQ brand={brand} mobile={mobile} />;
    case AccountType.Balloon:
      return <BalloonFAQ brand={brand} mobile={mobile} />;
    case AccountType.Loan:
      return <LoanFAQ brand={brand} mobile={mobile} />;
    default:
      return <></>;
  }
};

const FAQ: React.FC<{ country: Country; brand: Brand; accountType: AccountType; mobile: boolean }> = (props) => {
  const { country, brand, accountType, mobile } = props;
  const accountContext = useContext(AccountContext) as IAccountContext;
  const accounts = accountContext?.accounts;
  const { messages, subjectMappings, newmessageCount } = useMessageContext();
  let detailedAccountType = accountType;
  if (detailedAccountType === AccountType.Default && accounts?.Finance?.DetailedAccountType) {
    detailedAccountType = accounts?.Finance?.DetailedAccountType as unknown as AccountType;
  }

  if (!detailedAccountType) return <></>;

  useEffect(() => {
    if (
      accounts &&
      accounts.AccountId !== '' &&
      messages.messages.length >= 0 &&
      process.env.REACT_APP_ADOBE_ANALYTICS_FLAG === 'true'
    ) {
      generateSiteLoadEvent(accounts, subjectMappings as ISubjectMappingResponse, messages, newmessageCount as number);
    }
  }, [accounts, messages.messages]);

  return country === Country.Canada ? (
    <FAQComponentCanada brand={brand} accountType={detailedAccountType} mobile={mobile} />
  ) : (
    <FAQByAccountType brand={brand} accountType={detailedAccountType} mobile={mobile} />
  );
};

export default FAQ;
